module.exports = __webpack_public_path__ + "img/folders.e863f37a.svg";